import React, { useState } from "react";
import SmartSearchPanel from "./SmartSearchPanel";
import UploadCsvPanel from "./UploadCsvPanel";
import UploadResumesPanel from "./UploadResumesPanel";

const SUB_TABS = [
    {
        key: "smart",
        title: "Smart search",
        subtitle: "Find from your talent pool",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 3v3M12 18v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M3 12h3M18 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
            </svg>
        ),
    },
    {
        key: "csv",
        title: "Upload CSV",
        subtitle: "Import a prepared list",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6" />
            </svg>
        ),
    },
    {
        key: "resume",
        title: "Upload resumes",
        subtitle: "Add from document files",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6" />
                <path d="M9 15h6M9 11h6" />
            </svg>
        ),
    },
];

const AddCandidatesTab = ({ jobId, jobTitle, invitedCount, invitedEmails, onInvited }) => {
    const [activeSubTab, setActiveSubTab] = useState("smart");

    return (
        <div className="icv2-add-tab">
            <div className="icv2-hero">
                <div className="icv2-hero-text">
                    <span className="icv2-eyebrow">Source with confidence</span>
                    <h2>Build your candidate shortlist.</h2>
                    <p>
                        Bring the right people into {jobTitle ? <strong>{jobTitle}</strong> : "this role"} from wherever they are.
                        Your invite activity stays visible and organized here.
                    </p>
                </div>
                <div className="icv2-hero-badge">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 3v3M12 18v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M3 12h3M18 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
                    </svg>
                    {invitedCount} in invite list
                </div>
            </div>

            <div className="icv2-subtabs">
                {SUB_TABS.map((tab) => (
                    <button
                        key={tab.key}
                        className={`icv2-subtab-card${activeSubTab === tab.key ? " icv2-subtab-card--active" : ""}`}
                        onClick={() => setActiveSubTab(tab.key)}
                    >
                        <span className="icv2-subtab-icon">{tab.icon}</span>
                        <span className="icv2-subtab-text">
                            <strong>{tab.title}</strong>
                            <span>{tab.subtitle}</span>
                        </span>
                    </button>
                ))}
            </div>

            <div className="icv2-subtab-panel">
                {activeSubTab === "smart" && (
                    <SmartSearchPanel jobId={jobId} invitedEmails={invitedEmails} onInvited={onInvited} />
                )}
                {activeSubTab === "csv" && (
                    <UploadCsvPanel jobId={jobId} onInvited={onInvited} />
                )}
                {activeSubTab === "resume" && (
                    <UploadResumesPanel jobId={jobId} onInvited={onInvited} />
                )}
            </div>
        </div>
    );
};

export default AddCandidatesTab;
